import { LeaguePhase } from "../../sdk/model";

// Using this for data display, for example I want to know when I should be showing stats from what we have marked as the "current season" and when I should be showing last years stats by default
export function isPreSeason(phase: LeaguePhase | undefined) {
  if(!phase) {
    return false;
  }
  return phase === LeaguePhase.Offseason || phase === LeaguePhase.DraftPrep || phase === LeaguePhase.Draft || phase === LeaguePhase.TrainingCamp || phase === LeaguePhase.AuctionPrep || phase === LeaguePhase.Auction || phase === LeaguePhase.PreSeason;
}